import type { ReactNode } from 'react';

import { useAnchorable } from '../../hooks/useAnchorable';

import { codeBlock, pre } from './CodeBlock.css';
import type { TPostCodeBlockProps } from './CodeBlock.types';

export const PostCodeBlock = (props: TPostCodeBlockProps & { children?: ReactNode }) => {
  const { element, children } = props;
  const { anchorAttributes } = useAnchorable(element?.attrs);

  const highlightedCode = element?.attrs?.data?.highlighted_code;
  const rawText = element?.content?.[0]?.text;

  return (
    <div {...anchorAttributes} className={codeBlock}>
      <pre className={pre}>
        {children ||
          (highlightedCode ? <code dangerouslySetInnerHTML={{ __html: highlightedCode }} /> : <code>{rawText}</code>)}
      </pre>
    </div>
  );
};
